<template>
    
    <VehicleConfigurationNav v-if="!loading" @usage="setUsage" />
  
    <StepsToCalculateNav v-if="!loading" :fuelCost="costDiesel"  :equipment="costEquipment" :otherCost="costOther" :active="1" :usage="currentUsage" />

    <div class="container-fluid" v-if="!loading">
        <div class="row my-5">
            <div class="col-sm-6 vehicle-card-col">
                <VehicleCard :vehicle="vehicleInfo" />
            </div>
            <div class="col-sm-6 text-left vehicle-input-col">
                <p class="heading-3">Equipment Cost Input</p>
                <div class="d-none">
                    <button @click="currencyToggle()">currency toggle temp</button>
                    <div id="testing">{{this.currentCurrency}}</div>
                </div>
                <div class="input-block">

                    <!-- Vehicle Price -->
                    <div class="form-group mt-5">
                        <label for="dieselVehiclePrice" class="w-100">Vehicle Price ($)</label>
                        <input type="text" class="range-output output-text" v-model="vehiclePriceFormatted" @input="formatInputVehiclePrice(); calculateTotals()">
                        <input type="number" id="dieselVehiclePriceOutput" class="range-output d-none" min="0" max="500000" v-model="vehiclePrice"> 
                        <input class="form-control-range" type="range" id="dieselVehiclePrice" name="dieselVehiclePrice" min="0" max="500000" v-model="vehiclePrice" @input="calculateTotals(); formatInputFromSliderVehiclePrice()"> 
                    </div>

                    <!-- Vehicle Resale -->
                    <div class="form-group mt-5">
                        <label for="dieselVehicleResale" class="w-100">Vehicle Resale Value ($)</label>
                        <input type="text" class="range-output output-text" v-model="vehicleResaleFormatted" @input="formatInputVehicleResale(); calculateTotals()">
                        <input type="number" id="dieselVehicleResaleOutput" class="range-output d-none" min="0" max="500000" v-model="vehicleResale">
                        <input class="form-control-range" type="range" id="dieselVehicleResale" name="dieselVehicleResale" min="0" max="500000" v-model="vehicleResale" @input="calculateTotals(); formatInputFromSliderVehicleResale()">
                    </div>
                    
                    <!-- Amortization -->
                    <div class="form-group mt-5">
                        <label for="dieselAmortization" class="w-100">Amortization (years)</label>
                        <input type="number" id="dieselAmortizationOutput" class="range-output output-text" min="0" max="10" v-model="amortization" @input="calculateTotals()">
                        <input class="form-control-range" type="range" id="dieselAmortization" name="dieselAmortization" min="0" max="10" v-model="amortization" @input="convertValues(); calculateTotals()">
                    </div>

                </div>


                <div class="text-center next-link position-relative">
                    <router-link to="/diesel/other-costs" class="big-link heading-2 text-center" @click="trackNextCategory()">Next Step <img :src="`${imagePath}/arrow-white.png`" alt=""></router-link>
                </div>
            </div>
        </div>
    </div>

    <div class="container-footer" v-if="!loading">
        <div class="container-fluid">
            <div class="row py-4">
                <div class="col-sm-12">
                    <div class="totals-container d-flex w-100 justify-content-between">
                        <div class="totals-item miles-only">
                            <p class="text-uppercase">Equipment Costs Total</p>
                            <div class="d-flex justify-content-between">

                                <div class="mr-5">
                                    <p v-if="currentUsage == 'miles'" class="mb-0" id="costPerMileOuput" v-html="formatPrice((costEquipment['cost-per-mile']) * currencyExchange)"></p>
                                    <p v-if="currentUsage == 'hours'" class="mb-0" id="costPerMileOuput" v-html="formatPrice((costEquipment['cost-per-hour']) * currencyExchange)"></p>
                                    <small>Total Cost Per {{ currentUsage == 'miles' ? 'Mile' : 'Hour' }}</small>
                                </div>
                    
                                <div class="">
                                    <p class="mb-0" id="annualFuelCostOuput" v-html="formatPrice((costEquipment['annual-cost']) * currencyExchange, 0)"></p>
                                    <small>Total Annual Cost</small>
                                </div>

                            </div>
                        </div>
                        
                        <DieselFooter :fuelCost="costDiesel" :equipmentCost="costEquipment" :otherCost="costOther" :usage="currentUsage" />

                        <DieselSummaryModal :vehicle="vehicleInfo" :fuelCost="costDiesel" :equipment="costEquipment" :otherCost="costOther" :usage="currentUsage" />
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>

<script>
    import StepsToCalculateNav from "../components/StepsToCalculateNav.vue"
    import VehicleConfigurationNav from "@/components/VehicleConfigurationNav.vue"

    import VehicleCard from "../components/VehicleCard"
    import DieselFooter from "../components/DieselFooter"
    import DieselSummaryModal from "../components/DieselSummaryModal"

    export default {
        name: 'DieselEquipmentCosts',
        components: {
            VehicleCard,
            StepsToCalculateNav,
            VehicleConfigurationNav,
            DieselFooter,
            DieselSummaryModal
        },
        data () {
            return {
                currentUsage: 'miles', // set as default
                vehicleInfo: {},
                costDiesel: {},
                costEquipment: {},
                costOther: {},
                vehiclePrice: 0,
                vehiclePriceFormatted: 0,
                vehicleResale: 0,
                vehicleResaleFormatted: 0,
                amortization: 0,
                totalAnnualCost: 0,
                totalCostPerMile: 0,
                currencyType: '',
                currencyExchange: 0,
                currencyConversion: 1,
                loading: true,
                imagePath: process.env.VUE_APP_ASSET_LOCATION
            }
        },
        mounted() {

            // Set currency
            this.currencyType = sessionStorage.getItem('currency')
            this.currencyExchange = this.currencyType == 'canada' ? Number(localStorage.getItem('USDtoCAD')) : 1

            // Grab vehicle info from storage and begin filling in props
            // vehicleInfoHidden is for setting equivalent values for diesel and electric
            this.vehicleInfo = JSON.parse(localStorage.getItem('calculatorVehicleDiesel'))
            this.vehicleInfoHidden = JSON.parse(localStorage.getItem('calculatorVehicleElectric'))
            this.currentCurrency = sessionStorage.getItem('currency')

            this.costDiesel = JSON.parse(sessionStorage.getItem('dieselFuelCost'))
            this.costEquipment = JSON.parse(sessionStorage.getItem('dieselEquipmentCost'))
            this.costOther = JSON.parse(sessionStorage.getItem('dieselOtherCost'))

            // Set currency
            this.currencyType = sessionStorage.getItem('currency')
            this.currencyExchange = this.currencyType == 'canada' ? Number(localStorage.getItem('USDtoCAD')) : 1
            this.currencyConversion = Number(localStorage.getItem('USDtoCAD'))

            // If US from CA
            if (sessionStorage.getItem('fromCanada') != null && sessionStorage.getItem('fromCanada') == 'true') {
                this.vehiclePrice = Math.round(this.vehicleInfo.equipment.vehiclePrice / this.currencyConversion)
                this.vehicleResale = Math.round(this.vehicleInfo.equipment.resaleValue / this.currencyConversion)
            }

            // If CA from US
            if (sessionStorage.getItem('fromCanada') != null && sessionStorage.getItem('fromCanada') == 'false') {
                this.vehiclePrice = Math.round(this.vehicleInfo.equipment.vehiclePrice * this.currencyConversion)
                this.vehicleResale = Math.round(this.vehicleInfo.equipment.resaleValue * this.currencyConversion)
            }

            if (sessionStorage.getItem('fromCanada') == null) {
                this.vehiclePrice = this.vehicleInfo.equipment.vehiclePrice
                this.vehicleResale = this.vehicleInfo.equipment.resaleValue
            }

            this.amortization = this.vehicleInfo.equipment.amortization
            this.vehiclePriceFormatted = (this.vehiclePrice).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            this.vehicleResaleFormatted = (this.vehicleResale).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")

            this.convertValues()
            this.calculateTotals()

            this.loading = false

            // Tracking
            window.gtag('event', 'page_view', {
                page_title: 'Cost Calculator - Diesel Equipment Cost',
                page_location: '/diesel/equipment-costs'
            })

            this.usToCa = 1.27
            this.gallonToLitre = 3.79
            this.milesToKm = 1.61
        },

        watch: {
            vehiclePriceFormatted: function(newValue) {
                const result = newValue.replace(/[^0-9.]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                this.$nextTick(() => this.vehiclePriceFormatted = result)
            },
            vehicleResaleFormatted: function(newValue) {
                const result = newValue.replace(/[^0-9.]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                this.$nextTick(() => this.vehicleResaleFormatted = result)
            }
        },

        methods: {

            convertValues() {
                this.amortization = Number(this.amortization).toFixed(1)
            },

            calculateTotals() {

                // (Vehicle Price - Resale Value) / Amortization
                let totalEquipmentCosts = (this.vehiclePrice - this.vehicleResale)  / this.amortization

                
                let costPerMileOutput = this.vehicleInfo.fuel.mileage == 0 ? 0 : parseFloat(totalEquipmentCosts / this.vehicleInfo.fuel.mileage)
                let costPerHourOutput = this.vehicleInfo.fuel.hours == 0 ? 0 :parseFloat(totalEquipmentCosts / this.vehicleInfo.fuel.hours)

                // Set footer totals
                this.totalAnnualCost = totalEquipmentCosts
                this.totalCostPerMile = costPerMileOutput
                this.totalCostPerHour = costPerHourOutput


                // Kick final calculations to storage so we can keep the value for use on later tabs.
                //TODO  In the future, we should leverage VueX for any sort of data management. Great in-app storage.
                sessionStorage.setItem('dieselEquipmentCost', JSON.stringify({
                        'annual-cost': totalEquipmentCosts, 
                        'cost-per-mile': costPerMileOutput,
                        'cost-per-hour': costPerHourOutput 
                    })
                )

                this.costEquipment = JSON.parse(sessionStorage.getItem('dieselEquipmentCost'))

                // This Block of variables allows values to persist after going back
                // or after changing from Diesel Electric & vice-versa
                this.vehicleInfo.equipment.vehiclePrice = this.vehiclePrice
                this.vehicleInfo.equipment.resaleValue = this.vehicleResale

                this.vehicleInfo.equipment.amortization = this.amortization
                this.vehicleInfoHidden.equipment.amortization = this.amortization

                localStorage.setItem('calculatorVehicleDiesel', JSON.stringify(this.vehicleInfo))
                localStorage.setItem('calculatorVehicleElectric', JSON.stringify(this.vehicleInfoHidden))

            },

            currencyToggle() {
                if(this.currentCurrency == 'america') {
                    this.vehiclePrice = (this.vehiclePrice * this.usToCa).toFixed(0)
                    this.vehicleResale = (this.vehicleResale * this.usToCa).toFixed(0)

                    this.currentCurrency = 'canada'
                    this.calculateTotals()
                } else {
                    this.vehiclePrice = (this.vehiclePrice / this.usToCa).toFixed(0)
                    this.vehicleResale = (this.vehicleResale / this.usToCa).toFixed(0)

                    this.currentCurrency = 'america'
                    this.calculateTotals()
                }
            },
            // Sets Miles or Hours calculations based on selection in navigation
            setUsage(value) {
                (sessionStorage.getItem('usage') == null || sessionStorage.getItem('usage').length === 0) ? this.currentUsage = this.currentUsage : this.currentUsage = value
                this.calculateTotals()
            },

            formatInputVehiclePrice() {
                this.vehiclePriceFormatted = this.vehiclePriceFormatted.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                this.vehiclePrice = Number(this.vehiclePriceFormatted.replace(/,/g, ''))
            },
            formatInputFromSliderVehiclePrice() {
                this.vehiclePriceFormatted = Number(this.vehiclePrice).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },
            
            formatInputVehicleResale() {
                this.vehicleResaleFormatted = this.vehicleResaleFormatted.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                this.vehicleResale = Number(this.vehicleResaleFormatted.replace(/,/g, ''))
            },
            formatInputFromSliderVehicleResale() {
                this.vehicleResaleFormatted = Number(this.vehicleResale).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },

            formatPrice(value, spaces = 2) {
                let val = (value/1).toFixed(spaces)
                return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },
            trackNextCategory() {
                // Tracking
                window.gtag('event', 'Click', {
                    'event_category': 'Cost Calculator - Next Category',
                    'event_label': this.$route.path
                })
            },
        }
    }
    
</script>